export const sleepHabits = [
  {
    label: "How many hours of sleep do you typically get per night",
    key: "sleepPerNight",
    type: "select",
    options: [
      "Less than 4 hours",
      "4-6 hours",
      "6-8 hours",
      "More than 8 hours",
    ],
  },
  {
    label: "What time do you usually go to bed? ",
    key: "bedTime",
    type: "select",
    options: [
      "Before 9 PM",
      "Between 9 PM and 11 PM",
      "Between 11 PM and 1 AM",
      "After 1 AM",
    ],
  },
  {
    label: "How often do you wake up during the night? ",
    key: "wakeUpPerNights",
    type: "select",
    options: [
      "Never",
      "1 time per night",
      "2-3 times per night",
      "More than 3 times per night",
    ],
  },
  {
    label: "How do you typically feel when you wake up?",
    key: "wakupEnergy",
    type: "select",
    options: ["Refreshed and energetic", "Neutral", "Tired", "Exhausted"],
  },
];

export const sleepChallenges = [
  {
    label: "What are your biggest sleep issues? (Select all that apply)",
    key: "sleepIssues",
    type: "multi-select",
    options: [
      "Trouble falling asleep",
      "Trouble staying asleep",
      "Waking up too early",
      "Nightmares or restless sleep",
      "Worrying or stress",
      "Other",
    ],
  },
  {
    label: "How long have you been experiencing sleep problems?",
    key: "sleepProblemsDuration",
    type: "select",
    options: [
      "Less than 1 month",
      "1-6 months",
      "6 months to 1 year",
      "Longer than 1 year",
    ],
  },
];

export const lifeStyle = [
  {
    label: "How often do you exercise per week?",
    key: "exercisePerWeek",
    type: "select",
    options: ["Never", "1-2 times", "3-4 times", "More than 4 times"],
  },
  {
    label:
      "How often do you consume caffeine (coffee, tea, energy drinks) per day?",
    key: "teaTimes",
    type: "select",
    options: ["Never", "1 time", "2-3 times", "More than 3 times"],
  },
  {
    label:
      "Do you use electronic devices (such as a phone or tablet) before sleeping?",
    key: "electronicDeviceUse",
    type: "select",
    options: ["Never", "Sometimes", "Often", "Always"],
  },
];

export const sleepEnviornment = [
  {
    label: "How is the temperature in your bedroom?",
    key: "bedroomTemprature",
    type: "select",
    options: ["Too warm", "Perfectly comfortable", "Too cold"],
  },
  {
    label: "How quiet is your bedroom?",
    key: "bedroomNoise",
    type: "select",
    options: ["Completely quiet", "Light background noise", "Noisy"],
  },
  {
    label: "How dark is your bedroom while sleeping?",
    key: "roomBrightness",
    type: "select",
    options: ["Completely dark", "Dimmed light", "Bright light present"],
  },
];

export const sleepCoachOptions = [
  {
    label: "How many hours of sleep do you typically get per night",
    key: "sleepPerNight",
    type: "select",
    options: [
      "Less than 4 hours",
      "4-6 hours",
      "6-8 hours",
      "More than 8 hours",
    ],
  },
  {
    label: "What time do you usually go to bed? ",
    key: "bedTime",
    type: "select",
    options: [
      "Before 9 PM",
      "Between 9 PM and 11 PM",
      "Between 11 PM and 1 AM",
      "After 1 AM",
    ],
  },
  {
    label: "How often do you wake up during the night? ",
    key: "wakeUpPerNights",
    type: "select",
    options: [
      "Never",
      "1 time per night",
      "2-3 times per night",
      "More than 3 times per night",
    ],
  },
  {
    label: "How do you typically feel when you wake up?",
    key: "wakupEnergy",
    type: "select",
    options: ["Refreshed and energetic", "Neutral", "Tired", "Exhausted"],
  },
  {
    label: "What are your biggest sleep issues? (Select all that apply)",
    key: "sleepIssues",
    type: "multi-select",
    options: [
      "Trouble falling asleep",
      "Trouble staying asleep",
      "Waking up too early",
      "Nightmares or restless sleep",
      "Worrying or stress",
      "Other",
    ],
  },
  {
    label: "How long have you been experiencing sleep problems?",
    key: "sleepProblemsDuration",
    type: "select",
    options: [
      "Less than 1 month",
      "1-6 months",
      "6 months to 1 year",
      "Longer than 1 year",
    ],
  },
  {
    label: "How often do you exercise per week?",
    key: "exercisePerWeek",
    type: "select",
    options: ["Never", "1-2 times", "3-4 times", "More than 4 times"],
  },
  {
    label:
      "How often do you consume caffeine (coffee, tea, energy drinks) per day?",
    key: "teaTimes",
    type: "select",
    options: ["Never", "1 time", "2-3 times", "More than 3 times"],
  },
  {
    label:
      "Do you use electronic devices (such as a phone or tablet) before sleeping?",
    key: "electronicDeviceUse",
    type: "select",
    options: ["Never", "Sometimes", "Often", "Always"],
  },

  {
    label: "How is the temperature in your bedroom?",
    key: "bedroomTemprature",
    type: "select",
    options: ["Too warm", "Perfectly comfortable", "Too cold"],
  },
  {
    label: "How quiet is your bedroom?",
    key: "bedroomNoise",
    type: "select",
    options: ["Completely quiet", "Light background noise", "Noisy"],
  },
  {
    label: "How dark is your bedroom while sleeping?",
    key: "roomBrightness",
    type: "select",
    options: ["Completely dark", "Dimmed light", "Bright light present"],
  },
];

export const initialSleepData = {
  sleepPerNight: "",
  bedTime: "",
  wakeUpPerNights: "",
  wakupEnergy: "",
  sleepIssues: [],
  sleepProblemsDuration: "",
  exercisePerWeek: "",
  teaTimes: "",
  electronicDeviceUse: "",
  bedroomTemprature: "",
  bedroomNoise: "",
  roomBrightness: "",
};
